import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgPillsIcon(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={27}
      height={27}
      fill="none"
      viewBox="0 0 27 27"
      {...props}
    >
      <G clipPath="url(#clip0_1883:2288)">
        <Path
          fill="#D4CFC2"
          d="M25.722 17.052a4.365 4.365 0 01-6.173 0l-4.4-4.447.777-5.397 5.396-.776 4.4 4.448a4.365 4.365 0 010 6.172z"
        />
        <Path
          fill="#FF821F"
          d="M15.15 12.605L9.947 7.451A4.365 4.365 0 0116.12 1.28l5.202 5.154-6.172 6.172z"
        />
        <Path
          fill="#EB6800"
          d="M18.48 9.275l-5.203-5.154-.09-.088C11.3 2.251 13.812-.662 15.81.996c.106.088.21.182.31.282l5.203 5.154-2.843 2.843z"
        />
        <Path
          fill="#B2AEA6"
          d="M25.722 10.88a4.365 4.365 0 01-1.769 7.247 4.363 4.363 0 00-1.074-4.405L18.48 9.275l2.843-2.843 4.399 4.448z"
        />
        <Path
          fill="#F1EBDE"
          d="M1.278 25.722a4.365 4.365 0 010-6.173l4.448-4.4 5.396.777.776 5.396-4.448 4.4a4.365 4.365 0 01-6.172 0z"
        />
        <Path
          fill="#FF821F"
          d="M5.726 15.15l5.154-5.203a4.365 4.365 0 016.173 6.173l-5.154 5.202-6.173-6.172z"
        />
        <Path
          fill="#EB6800"
          d="M9.056 18.48l5.154-5.203a4.363 4.363 0 001.074-4.404 4.365 4.365 0 011.768 7.247l-5.154 5.202-2.842-2.842z"
        />
        <Path
          fill="#D4CFC2"
          d="M7.45 25.722a4.365 4.365 0 01-7.246-1.769 4.363 4.363 0 004.404-1.074l4.448-4.399 2.843 2.843-4.448 4.399z"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_1883:2288">
          <Path fill="#fff" d="M0 0h27v27H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default SvgPillsIcon
